// extracted by mini-css-extract-plugin
export default {"info":"JT+RN-i-uE","h-rule":"-fLUGB8GmU","hRule":"-fLUGB8GmU","logo":"gFLenP8XV9","generate-api-key-button":"GfgVQqurKa","generateApiKeyButton":"GfgVQqurKa","further-resources":"op6yyZvrmP","furtherResources":"op6yyZvrmP"};
    if(module.hot) {
      // 1648554153681
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  